import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractCaseTransformations from "./abstractCaseTransformations";

const settlementTransformations: FormTransformations = {
  dateFields: [
    ...(abstractCaseTransformations.dateFields || []),
    { path: "insuranceCoverageDate", type: "date" },
    { path: "settlementReachedDate", type: "date" },
    { path: "settlementRevocationDate", type: "date" },
    { path: "dismissalProtectionSuitDeadline", type: "date" },
    { path: "petitioner.birthDate", type: "date" },
    { path: "employedSince", type: "date" },
    { path: "contractTerminationReceivedDate", type: "date" },
    { path: "contractTerminationDate", type: "date" },
    { path: "contractDate", type: "date" },
    { path: "powerOfAttorney", type: "dateTime" },
    { path: "finalJudgement", type: "date" },
    { path: "lastWorkDayCalculated", type: "date" },
    { path: "lastWorkDayCancellation", type: "date" },
    { path: "verification", type: "dateTime" },
  ],
  numberFields: [
    ...(abstractCaseTransformations.numberFields || []),
    "leadStatus",
    "applicationStatus",
    "numberChildren",
    "numberOfEmployees",
    "responsibleCourt.advoAssistId",
  ],
  floatFields: [
    ...(abstractCaseTransformations.floatFields || []),
    "grossSalary",
    "valueInDispute",
    "nWnFAmount",
    "caseInsurance.deductible",
  ],
  ibanFields: abstractCaseTransformations.ibanFields,
};
export default settlementTransformations;
